/**
 * ADRE Online Licensing System Web API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BadAnswerModel } from './badAnswerModel';
import { BadSectionModel } from './badSectionModel';


/**
 * Broker Audit Questionnaire model
 */
export class BadQuestionnaireModel { 
    LastUpdated?: Date;
    AdditionalInformationComments?: string;
    Sections?: Array<BadSectionModel>;
    Answers?: Array<BadAnswerModel>;
}



// WEBPACK FOOTER //
// ./src/app/model/badQuestionnaireModel.ts